import React from 'react'
import {FaGithub} from 'react-icons/fa'
import CreditCardProjectImg from '../assets/creditcard.png'
import realEstate from '../assets/realestate.jpg'
import SpotifyProjectImg from '../assets/spotify.jpg'
import NewsProjectImg from '../assets/news.jpg'
import FishingBotProjectImg from '../assets/fishing.png'
import CloudSharingProjectImg from '../assets/cloudshare.jpg'
import NBAProjectImg from '../assets/nba.png'

const Projects = () => {
  return (
    <div className='w-full md:h-screen text-[#000000] bg-[#617ea3]'>
        {/* container */}
        <div className='max-w-[1000px] mx-auto p-4 flex flex-col justify-center w-full h-full'>
            <div className='sm:hidden mt-72 bg-black'></div>
            <div name='projects' className='pb-4 pt-96 mt-96 sm:mt-0 sm:pt-0'>
                <p className='text-4xl font-bold inline border-b-4 text-[#1c337b] border-[#14213d]'>Projects</p>
                <p className='py-6 font-bold'>Here are all the projects I have worked on!</p>
            </div>
            {/* grid container */}
            <div className='grid sm:grid-cols-2 md:grid-cols-3 gap-4'>

                {/* card item */}
                <div style={{backgroundImage: `url(${CreditCardProjectImg})`, backgroundSize: 'cover', backgroundPosition: 'right'}}
                className='shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div'>
                    {/* hover effect */}
                    <div className='opacity-0 group-hover:opacity-100 text-center'>
                        <span className='text-2xl font-bold text-white'>
                            Credit Card Fraud Detection Program
                        </span>
                        <div className='pt-8 text-center'>
                            <a href="/">
                                <button className='text-center rounded-lg px-4 py-3 mg-2 bg-white text-gray-700 font-bold text-lg'>
                                    <a className='flex jusitfy-between items-center' href="https://github.com/shriraj-m/Credit-Card-Fraud-Detection-Program" target='_blank'>Github <FaGithub className='pl-2 w-full' size={30}/></a>
                                </button>
                            </a>
                        </div>
                    </div>
                </div>

                <div style={{backgroundImage: `url(${NewsProjectImg})`}}
                className='shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div'>
                    {/* hover effect */}
                    <div className='opacity-0 group-hover:opacity-100 text-center'>
                        <span className='text-2xl font-bold text-white'>
                            Real-Time News Sentiment-Analysis
                        </span>
                        <div className='pt-8 text-center'>
                            <a href="/">
                                <button className='text-center rounded-lg px-4 py-3 mg-2 bg-white text-gray-700 font-bold text-lg'>
                                    <a className='flex jusitfy-between items-center' href="https://github.com/shriraj-m/Real-Time-News-Sentiment-Analysis" target='_blank'>Github <FaGithub className='pl-2 w-full' size={30}/></a>
                                </button>
                            </a>
                        </div>
                    </div>
                </div>

                {/* card item */}
                <div style={{backgroundImage: `url(${FishingBotProjectImg})`}}
                className='shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div'>
                    {/* hover effect */}
                    <div className='opacity-0 group-hover:opacity-100 text-center'>
                        <span className='text-2xl font-bold text-white'>
                        Fishing Mini-Game Discord-Bot
                        </span>
                        <div className='pt-8 text-center'>
                            <a href="/">
                                <button className='text-center rounded-lg px-4 py-3 mg-2 bg-white text-gray-700 font-bold text-lg'>
                                    <a className='flex jusitfy-between items-center' href="https://github.com/shriraj-m/fishing-discord-bot" target='_blank'>Github <FaGithub className='pl-2 w-full' size={30}/></a>
                                </button>
                            </a>
                        </div>
                    </div>
                </div>

                <div style={{backgroundImage: `url(${CloudSharingProjectImg})`}}
                className='shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div'>
                    {/* hover effect */}
                    <div className='opacity-0 group-hover:opacity-100 text-center'>
                        <span className='text-2xl font-bold text-white'>
                            Socket and Cloud Based File Sharing
                        </span>
                        <div className='pt-8 text-center'>
                            <a href="/">
                                <button className='text-center rounded-lg px-4 py-3 mg-2 bg-white text-gray-700 font-bold text-lg'>
                                    <a className='flex jusitfy-between items-center' href="https://github.com/shriraj-m/Socket-Based-Cloud-File-Sharing" target='_blank'>Github <FaGithub className='pl-2 w-full' size={30}/></a>
                                </button>
                            </a>
                        </div>
                    </div>
                </div>

                {/* card item */}
                <div style={{backgroundImage: `url(${SpotifyProjectImg})`}}
                className='shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div'>
                    {/* hover effect */}
                    <div className='opacity-0 group-hover:opacity-100 text-center'>
                        <span className='text-2xl font-bold text-white'>
                            Your Top-10 Songs using SpotifyAPI
                        </span>
                        <div className='pt-8 text-center'>
                            <a href="/">
                                <button className='text-center rounded-lg px-4 py-3 mg-2 bg-white text-gray-700 font-bold text-lg'>
                                    <a className='flex jusitfy-between items-center' href="https://github.com/shriraj-m/top10-songs-spotify" target='_blank'>Github <FaGithub className='pl-2 w-full' size={30}/></a>
                                </button>
                            </a>
                        </div>
                    </div>
                </div>

                <div style={{backgroundImage: `url(${NBAProjectImg})`}}
                className='shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div'>
                    {/* hover effect */}
                    <div className='opacity-0 group-hover:opacity-100'>
                        <span className='text-2xl font-bold text-white tracking-wider'>
                            NBA Season Predictor
                        </span>
                        <div className='pt-8 text-center'>
                            <a href="/">
                                <button className='text-center rounded-lg px-4 py-3 mg-2 bg-white text-gray-700 font-bold text-lg'>
                                    <a className='flex jusitfy-between items-center' href="https://github.com/shriraj-m/nba-season-predictor" target='_blank'>Github <FaGithub className='pl-2 w-full' size={30}/></a>
                                </button>
                            </a>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
  )
}

export default Projects